"use client"

import { useParams, usePathname } from "next/navigation"
import { computeRoute } from "@vercel/analytics"
import { Analytics } from "@vercel/analytics/react"
import { usePrerenderSafeSearchParams } from "@/hooks/use-prerender-safe-search-params"

/**
 * Same as `@vercel/analytics/next`, minus its `useSearchParams` Suspense
 * boundary, which left a client-render bailout in every page's static HTML.
 * Route and path are computed the way that wrapper computes them.
 */
export function VercelAnalytics() {
  const params = useParams()
  const searchParams = usePrerenderSafeSearchParams()
  const path = usePathname()
  const route = params
    ? computeRoute(path, Object.keys(params).length ? (params as Record<string, string | string[]>) : Object.fromEntries(searchParams.entries()))
    : null

  return (
    <Analytics
      path={path}
      route={route}
      basePath={process.env.NEXT_PUBLIC_VERCEL_OBSERVABILITY_BASEPATH}
      configString={process.env.NEXT_PUBLIC_VERCEL_OBSERVABILITY_CLIENT_CONFIG}
      framework="next"
    />
  )
}
